import _styled from '@emotion/styled/base';
import { keyframes } from '@emotion/react';
import { spacing, border, motion, opacity } from '@hubble/tokens/web';
import * as MenuPrimitive from '@radix-ui/react-dropdown-menu';
import { ScrollArea } from '../ScrollArea/index.js';

const close = keyframes`
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(-8px) scale(0.95);
  }
`;
const open = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;
const MenuStyles = _styled(ScrollArea, {
  target: "e78fubs5"
})("display:flex;flex-direction:column;padding:", spacing[8], ";border-radius:", border.radius.md, ";width:", ({
  width
}) => width ? width : '256px', ";max-height:", ({
  height
}) => height ? height : '384px', ";z-index:9999;background-color:", ({
  theme
}) => theme.colorScheme.elevated.background.menu, ";box-shadow:", ({
  theme
}) => theme.isDark ? '0' : '0px 8px 24px 0px rgba(103, 104, 104, 0.16), 0px 4px 8px 0px rgba(103, 104, 104, 0.12), 0px 0px 0px 1px rgba(103, 104, 104, 0.04)', ";@media (prefers-reduced-motion: no-preference){animation-duration:", motion.duration.intermediate, ";animation-timing-function:cubic-bezier(0.2, 0.8, 0.4, 1);transform-origin:var(--radix-dropdown-menu-content-transform-origin);&[data-state='open']{animation-name:", open, ";}&[data-state='closed']{animation-name:", close, ";}}");
const MenuLabelStyles = _styled(MenuPrimitive.Label, {
  target: "e78fubs4"
})("display:flex;align-self:stretch;align-items:flex-start;margin:", spacing[8], " ", spacing[8], " 0;color:", ({
  theme
}) => theme.colorScheme.content.secondary, ";");
const MenuGroupStyles = _styled(MenuPrimitive.Group, {
  target: "e78fubs3"
})("display:flex;flex-direction:column;align-items:flex-start;align-self:stretch;gap:", spacing[4], ";");
const RadioGroupStyles = _styled(MenuPrimitive.RadioGroup, {
  target: "e78fubs2"
})("display:flex;flex-direction:column;align-items:flex-start;align-self:stretch;gap:", spacing[4], ";");
const MenuItemStyles = _styled('div', {
  target: "e78fubs1"
})("all:unset;display:flex;text-align:left;padding:", spacing[8], ";align-items:center;gap:", spacing[12], ";align-self:stretch;border-radius:", border.radius.md, ";outline:0;user-select:none;transition:transform ", motion.duration.fast, " ", motion.timing.easeInOut, ",background-color ", motion.duration.fast, " ", motion.timing.easeInOut, ";background-color:", ({
  theme
}) => theme.colorScheme.action.background.tertiary.neutral.enabled, ";color:", ({
  theme
}) => theme.colorScheme.content.primary, ";&:not([data-presentational='true']){cursor:pointer;}&:not([data-presentational='true']):hover{background-color:", ({
  theme
}) => theme.colorScheme.action.background.tertiary.neutral.hover, ";}&:not([data-presentational='true']):active{transform:scale(0.98);background-color:", ({
  theme
}) => theme.colorScheme.action.background.tertiary.neutral.active, ";}&:not([data-presentational='true']):focus{background-color:", ({
  theme
}) => theme.colorScheme.action.background.tertiary.neutral.focus, ";}&[aria-disabled='true'],&[aria-disabled='true']:hover,&[aria-disabled='true']:active,&[aria-disabled='true']:focus{cursor:default;transform:scale(1);background-color:", ({
  theme
}) => theme.colorScheme.action.background.tertiary.neutral.disabled, ";color:", ({
  theme
}) => theme.colorScheme.content.disabled, ";}&[aria-disabled='true'] [data-visual-element='true']{opacity:", opacity.disabledGraphic, ";}");
const MenuSeparatorStyles = _styled(MenuPrimitive.Separator, {
  target: "e78fubs0"
})("display:flex;align-self:stretch;margin:", spacing[4], " ", spacing[8], ";height:1px;background:", ({
  theme
}) => theme.colorScheme.border.secondary, ";");

export { MenuGroupStyles, MenuItemStyles, MenuLabelStyles, MenuSeparatorStyles, MenuStyles, RadioGroupStyles };
